import { memo } from 'react';

import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router';
import type { RouteComponentProps } from 'react-router';
import { compose, setDisplayName, withProps, withState } from 'recompact';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { errorBoundary, withClient } from 'src/app/hocs';
import { login, notFound } from 'src/app/router/paths';
import { segmentTrack } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import { ChangePassword } from '.';

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    redirectToLogin: () => dispatch(push(login.route)),
    redirectTo404: () => dispatch(push(notFound.route)),
    dispatchSegmentTrack: (event: UnifiedEvent, payload: any) => dispatch(segmentTrack(event, payload)),
  };
}
const connector = connect(undefined, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

interface MatchParams {
  code: string;
  encodedUserId: string;
  token: string;
}

export default compose(
  setDisplayName('ChangePasswordContainer'),
  connector,
  withClient,
  errorBoundary,
  withRouter,
  withProps((props: RouteComponentProps<MatchParams>) => {
    const { code } = props.match.params;

    return {
      code,
    };
  }),
  withState('customErrorMarkup', 'setCustomErrorMarkup', null),
  memo
)(ChangePassword);
